<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useTutorKanbanStore } from '../model/store'
import { useShowTutorApi } from '../api/show.hook'
import { useAgentsApi } from '../api/agents.hook'
import TutorKanbanGeneral from './TutorKanbanGeneral.vue'

defineOptions({
  name: 'TutorKanbanInfoPage',
})

const tutorKanbanStore = useTutorKanbanStore()
const route = useRoute()

useOnTimezoneChange(() => {
  const tutorId = route.params.id
  void useShowTutorApi({ tutorId: `${tutorId}` })
  void useAgentsApi()
})
</script>

<template>
  <TutorKanbanGeneral 
    v-if="tutorKanbanStore.getTutor" 
  />
</template>
